var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// eslint-disable-next-line no-use-before-define
import React, { useEffect, useRef, useState, useCallback } from 'react';
import animationStyles from './animationStyles';
var Textra = function (props) {
    var selectedAnimation = props.effect || 'simple';
    var animationRef = useRef(null);
    var _a = useState(animationStyles[selectedAnimation][0]), style = _a[0], setStyle = _a[1];
    var textArrIndex = useRef(0);
    var _b = useState(props.data[textArrIndex.current]), text = _b[0], setText = _b[1];
    var previousTime = useRef(null);
    var duration = props.duration || 500;
    var stopDuration = props.stopDuration || 3000;
    var initialRound = stopDuration + duration;
    var currentRoundTime = useRef(initialRound);
    var singleRoundTime = stopDuration + 2 * duration;
    var hasUpdatedText = useRef(false);
    var easeOutQuad = function (t) { return t * (2 - t); };
    useEffect(function () {
        setStyle(animationStyles[selectedAnimation][0]);
    }, [selectedAnimation]);
    useEffect(function () {
        setText(props.data[textArrIndex.current]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [textArrIndex.current, props.data]);
    var runShowTextAnimation = function (elapsed) {
        var showingTranlateInitial = animationStyles[selectedAnimation][1].translate.value;
        var showingTranlateDiffrence = animationStyles[selectedAnimation][1].translate.value - animationStyles[selectedAnimation][0].translate.value;
        // const showingOpacityInitial = animationStyles[selectedAnimation][1].opacity
        // const showingOpacityDiffrence = animationStyles[selectedAnimation][1].opacity - (animationStyles[selectedAnimation][1].opacity - animationStyles[selectedAnimation][0].opacity)
        var showingTiming = easeOutQuad((elapsed - currentRoundTime.current) / duration);
        setStyle(function (s) { return ({
            translate: __assign(__assign({}, s.translate), { value: showingTranlateInitial - showingTranlateDiffrence * showingTiming }),
            opacity: showingTiming
        }); });
    };
    var runHideTextAnimation = function (elapsed) {
        var hidingTraslateInitial = animationStyles[selectedAnimation][0].translate.value;
        var hidingTranslateDiffrence = animationStyles[selectedAnimation][0].translate.value - animationStyles[selectedAnimation][1].translate.value;
        var hidingOpacityInitial = animationStyles[selectedAnimation][0].opacity;
        // const hidingOpacityDiffrence = animationStyles[selectedAnimation][1].opacity - (animationStyles[selectedAnimation][0].opacity - animationStyles[selectedAnimation][1].opacity)
        var hidingTiming = easeOutQuad((elapsed - (currentRoundTime.current - duration)) / duration);
        setStyle(function (s) { return ({
            translate: __assign(__assign({}, s.translate), { value: hidingTraslateInitial - hidingTranslateDiffrence * hidingTiming }),
            opacity: hidingOpacityInitial - hidingTiming
        }); });
    };
    var updateTextIndex = function () {
        if (textArrIndex.current === (props.data.length - 1)) {
            textArrIndex.current = 0;
        }
        else {
            textArrIndex.current = textArrIndex.current + 1;
        }
    };
    var runAnimation = useCallback(function (timestamps) {
        if (previousTime.current === null)
            previousTime.current = timestamps;
        var elapsed = timestamps - previousTime.current;
        if (elapsed > currentRoundTime.current &&
            elapsed < currentRoundTime.current + duration) {
            runShowTextAnimation(elapsed);
        }
        if (elapsed > currentRoundTime.current - duration &&
            elapsed < currentRoundTime.current) {
            runHideTextAnimation(elapsed);
        }
        if (elapsed > currentRoundTime.current) {
            if (!hasUpdatedText.current) {
                updateTextIndex();
                hasUpdatedText.current = true;
            }
        }
        if (elapsed > currentRoundTime.current + duration) {
            hasUpdatedText.current = false;
            currentRoundTime.current += singleRoundTime;
        }
        animationRef.current = window.requestAnimationFrame(runAnimation);
    }, [selectedAnimation, props.data.length, singleRoundTime, duration]);
    useEffect(function () {
        animationRef.current = window.requestAnimationFrame(runAnimation);
        return function () { return window.cancelAnimationFrame(animationRef.current); };
    }, [runAnimation, props.effect]);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", __assign({ style: {
                display: 'inline-block',
                transform: style.translate.type + "(" + style.translate.value + style.translate.unit + ")",
                opacity: style.opacity
            } }, props), text)));
};
export default Textra;
